// const user_login = 'https://admin.droproblem.com/api/user/login'
// const user_logout = 'https://admin.droproblem.com/api/user/logout'
const user_info = 'https://admin.droproblem.com/api/user/info'

// const user_genVCode = 'https://admin.droproblem.com/api/user/genVCode'
// const user_genVCodeImageSrc = 'https://admin.droproblem.com/'
// const client_find = 'https://admin.droproblem.com/api/pc/client/find'

// const client_detail = 'https://admin.droproblem.com/api/pc/client/detail'
// const client_delete = 'https://admin.droproblem.com/api/pc/client/delete'

// const user_find = 'https://admin.droproblem.com/api/pc/user/find'
// const client_getShortNameList = 'https://admin.droproblem.com/api/pc/client/getShortNameList'
// const client_getFullNameList = 'https://admin.droproblem.com/api/pc/client/getFullNameList'
// const client_getPoTypeOptions = 'https://admin.droproblem.com/api/pc/client/getPoTypeOptions'
// const invoice_create = 'https://admin.droproblem.com/api/pc/client/invoice/create'
// const invoice_delete = 'https://admin.droproblem.com/api/pc/client/invoice/delete'
// const invoice_update = 'https://admin.droproblem.com/api/pc/client/invoice/update'

// const representative_create = 'https://admin.droproblem.com/api/pc/client/representative/create'
// const representative_delete = 'https://admin.droproblem.com/api/pc/client/representative/delete'
// const representative_update = 'https://admin.droproblem.com/api/pc/client/representative/update'

// const client_update = 'https://admin.droproblem.com/api/pc/client/update'
// const client_checkFullName = 'https://admin.droproblem.com/api/pc/client/checkFullName'
// const client_checkShortName = 'https://admin.droproblem.com/api/pc/client/checkShortName'
// const client_checkEmail = 'https://admin.droproblem.com/api/pc/client/checkEmail'
// const client_create = 'https://admin.droproblem.com/api/pc/client/create'

const user_getNumberList = 'https://admin.droproblem.com/api/pc/user/getNumberList'
const user_getNicknameList = 'https://admin.droproblem.com/api/pc/user/getNicknameList'

const user_getNameList = 'https://admin.droproblem.com/api/pc/user/getNameList'
// const user_detail = 'https://admin.droproblem.com/api/pc/user/detail'
// const user_delete = 'https://admin.droproblem.com/api/pc/user/delete'
// const user_update = 'https://admin.droproblem.com/api/pc/user/update'
// const user_create = 'https://admin.droproblem.com/api/pc/user/create'

// const sort_find = 'https://admin.droproblem.com/api/pc/sort/find'
// const sort_detail = 'https://admin.droproblem.com/api/pc/sort/detail'
const sort_getSortNumberList = 'https://admin.droproblem.com/api/pc/sort/getSortNumberList'
// const sort_delete = 'https://admin.droproblem.com/api/pc/sort/delete'
// const sort_update = 'https://admin.droproblem.com/api/pc/sort/update'
// const sort_create = 'https://admin.droproblem.com/api/pc/sort/create'

// const group_find = 'https://admin.droproblem.com/api/pc/group/find'
const group_location_find = 'https://admin.droproblem.com/api/pc/group/location/find'
// const group_create = 'https://admin.droproblem.com/api/pc/group/create'
// const group_detail = 'https://admin.droproblem.com/api/pc/group/detail'
// const group_update = 'https://admin.droproblem.com/api/pc/group/update'

// const location_create = 'https://admin.droproblem.com/api/pc/group/location/create'
// const location_update = 'https://admin.droproblem.com/api/pc/group/location/update'
// const location_delete = 'https://admin.droproblem.com/api/pc/group/location/delete'

// const shift_create = 'https://admin.droproblem.com/api/pc/group/shift/create'
// const shift_update = 'https://admin.droproblem.com/api/pc/group/shift/update'
// const shift_delete = 'https://admin.droproblem.com/api/pc/group/shift/delete'





const user_genVCode = 'https://admin.droproblem.com/api/pc/admin/getCaptcha'
const user_genVCodeImageSrc = 'https://admin.droproblem.com/api/'
const client_find = 'https://admin.droproblem.com/api/pc/client/page'
const client_getPoTypeOptions = 'https://admin.droproblem.com/api/pc/client/getAllPoType'
const client_getShortNameList = 'https://admin.droproblem.com/api/pc/client/getPageShortName'
const client_selectByShortNameList = 'https://admin.droproblem.com/api/pc/client/selectByShortName'

const client_getFullNameList = 'https://admin.droproblem.com/api/pc/client/getPageFullName'
const client_detail = 'https://admin.droproblem.com/api/pc/client/selectById'
const invoice_create = 'https://admin.droproblem.com/api/pc/invoice/info/insert'
const invoice_update = 'https://admin.droproblem.com/api/pc/invoice/info/updateById'
const invoice_delete = 'https://admin.droproblem.com/api/pc/invoice/info/deleteById'
const representative_create = 'https://admin.droproblem.com/api/pc/representative/info/insert'
const representative_update = 'https://admin.droproblem.com/api/pc/representative/info/updateById'
const representative_delete = 'https://admin.droproblem.com/api/pc/representative/info/deleteById'
const client_checkFullName = 'https://admin.droproblem.com/api/pc/client/checkDuplicateFullName'
const client_checkShortName = 'https://admin.droproblem.com/api/pc/client/checkDuplicateShortName'
const client_checkEmail = 'https://admin.droproblem.com/api/pc/client/checkDuplicateEmail'
const client_create = 'https://admin.droproblem.com/api/pc/client/insert'



const group_find = 'https://admin.droproblem.com/api/pc/location/group/page'
const group_create = 'https://admin.droproblem.com/api/pc/location/group/insert'
const group_update = 'https://admin.droproblem.com/api/pc/location/group/updateById'
const group_updatecurrentgroup = 'https://admin.droproblem.com/api/pc/location/group/updateCurrentGroup'
const group_detail = 'https://admin.droproblem.com/api/pc/location/group/selectById'
const shift_create = 'https://admin.droproblem.com/api/pc/shift/insert'
const shift_update = 'https://admin.droproblem.com/api/pc/shift/updateById'
const shift_delete = 'https://admin.droproblem.com/api/pc/shift/deleteById'
const location_create = 'https://admin.droproblem.com/api/pc/location/insert'
const location_delete = 'https://admin.droproblem.com/api/pc/location/deleteById'
const location_update = 'https://admin.droproblem.com/api/pc/location/updateById'
const group_deleteById = 'https://admin.droproblem.com/api/pc/location/group/deleteById'

const sys_dictgroup = 'https://admin.droproblem.com/api/pc/sys/dict/group/getAll'

const user_find = 'https://admin.droproblem.com/api/pc/employee/page'
const client_update = 'https://admin.droproblem.com/api/pc/client/updateById'
const client_delete = 'https://admin.droproblem.com/api/pc/client/deleteById'
const user_detail = 'https://admin.droproblem.com/api/pc/employee/selectById'
const locationGroup_selectAll = 'https://admin.droproblem.com/api/pc/location/group/selectAll'
const user_update = 'https://admin.droproblem.com/api/pc/employee/updateById'
const user_create = 'https://admin.droproblem.com/api/pc/employee/insert'
const user_delete = 'https://admin.droproblem.com/api/pc/employee/deleteById'
const user_generationCompoundNumber = 'https://admin.droproblem.com/api/pc/employee/generationCompoundNumber'
const location_selectAll = 'https://admin.droproblem.com/api/pc/location/selectAll'
const sort_delete = 'https://admin.droproblem.com/api/pc/sort/deleteById'
const sort_update = 'https://admin.droproblem.com/api/pc/sort/updateById'
const sort_create = 'https://admin.droproblem.com/api/pc/sort/insert'
const file_upload = 'https://admin.droproblem.com/api/pc/file/upload'
const part_insert = 'https://admin.droproblem.com/api/pc/part/number/insert'
const part_deleteById = 'https://admin.droproblem.com/api/pc/part/number/deleteById'
const part_updateById = 'https://admin.droproblem.com/api/pc/part/number/updateById'

const client_pageBySortType = 'https://admin.droproblem.com/api/pc/client/pageBySortType'

const inspection_page = 'https://admin.droproblem.com/api/pc/inspection/record/page'
const sort_page = 'https://admin.droproblem.com/api/pc/sort/page'

const record_updateById = 'https://admin.droproblem.com/api/pc/inspection/record/updateById'
const record_approved = 'https://admin.droproblem.com/api/pc/inspection/record/approved'
const record_reviewRejection = 'https://admin.droproblem.com/api/pc/inspection/record/reviewRejection'
const record_export = 'https://admin.droproblem.com/api/client/report/export'


const daily_sort = 'https://admin.droproblem.com/api/pc/daily/report/sort'
const daily_shift = 'https://admin.droproblem.com/api/pc/daily/report/shift'
const daily_part = 'https://admin.droproblem.com/api/pc/daily/report/part'
const daily_export = 'https://admin.droproblem.com/api/pc/daily/report/shift/export'
const api_getTimeStamp = 'https://admin.droproblem.com/api/open/api/getTimeStamp'

const report_selectNokPhoto = 'https://admin.droproblem.com/api/client/report/selectNokPhoto'
const record_statistics = 'https://admin.droproblem.com/api/client/report/statistics'

const inbound_export = 'https://admin.droproblem.com/api/pc/portal/inbound/no/detail/export'
const inbound_statistics = 'https://admin.droproblem.com/api/pc/portal/inbound/no/detail/statistics'
const user_login = 'https://admin.droproblem.com/api/pc/portal/admin/login'
const sku_page = 'https://admin.droproblem.com/api/pc/portal/sku/page'
const user_logout = 'https://admin.droproblem.com/api/pc/portal/admin/logout'
const sort_listByInbound = 'https://admin.droproblem.com/api/pc/portal/sort/listByPartNumber'
const inbound_detail_page = 'https://admin.droproblem.com/api/pc/portal/inbound/no/detail/page'


const user_login_mobile = 'https://admin.droproblem.com/api/client/mobile/admin/login'
const sort_find_mobile = 'https://admin.droproblem.com/api/client/mobile/sort/pageBySortNumber'
const user_logout_mobile = 'https://admin.droproblem.com/api/client/mobile/admin/logout'
const report_selectNokPhoto_mobile = 'https://admin.droproblem.com/api/client/mobile/report/selectNokPhoto'
const sort_detail_mobile = 'https://admin.droproblem.com/api/client/mobile/report/page'
const record_statistics_mobile = 'https://admin.droproblem.com/api/client/mobile/report/statistics'




export default {
    inbound_detail_page,
    inbound_statistics,
    inbound_export,
    record_statistics_mobile,
    sort_detail_mobile,
    report_selectNokPhoto_mobile,
    user_logout_mobile,
    sort_find_mobile,
    user_login_mobile,
    report_selectNokPhoto,
    record_statistics,
    api_getTimeStamp,
    daily_export,
    daily_sort,
    daily_shift,
    daily_part,
    user_login,
    user_genVCode,
    user_genVCodeImageSrc,
    client_find,
    client_detail,
    client_delete,
    user_find,
    client_getShortNameList,
    client_getFullNameList,
    client_getPoTypeOptions,
    invoice_create,
    invoice_delete,
    client_update,
    invoice_update,
    representative_create,
    representative_delete,
    representative_update,
    client_checkFullName,
    client_checkShortName,
    client_checkEmail,
    client_create,
    user_getNumberList,
    user_getNicknameList,
    user_getNameList,
    user_detail,
    user_delete,
    user_update,
    user_create,
    sku_page,
    sort_listByInbound,
    sort_getSortNumberList,
    sort_delete,
    sort_update,
    group_find,
    group_location_find,
    sort_create,
    group_create,
    group_detail,
    location_create,
    shift_create,
    shift_update,
    shift_delete,
    location_update,
    location_delete,
    group_update,
    user_logout,
    user_info,
    group_updatecurrentgroup,
    group_deleteById,
    sys_dictgroup,
    locationGroup_selectAll,
    user_generationCompoundNumber,
    location_selectAll,
    file_upload,
    part_insert,
    part_deleteById,
    part_updateById,
    client_pageBySortType,
    client_selectByShortNameList,
    inspection_page,
    sort_page,
    record_updateById,
    record_reviewRejection,
    record_approved,
    record_export
}


// WEBPACK FOOTER //
// ./src/common/interface/url.js